<template>
    <div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'Carousel1Wrapper',
}
</script>

<style>
    
</style>